import { useState } from 'react'
import { useHistory } from 'react-router'
import Card from '@material-ui/core/Card'
import { ROLES } from '../../../config/user'
import { ITemplate } from '../../../types/templates'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import { useSession } from '../../../context/SessionContext'
import Alert, { ActionsOptType } from '../../../components/Alert'

/**
 * define styles for the component
*/
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: '14rem',
    maxHeight: '14rem', 
    border: '1.5px solid #d3d4d5',
    "&:hover":{
      transform: 'scale(1.05)',
      transition: '0.3s',
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.06)"
    },
  },
  title: {
    lineHeight: 1.2,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontSize: '1.2rem',
  },
  description: {
    whiteSpace: 'pre-line',
    marginTop: '1.5vh',
    textAlign: 'justify',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
  },
})

/**
 * Custom `TemplateItemTypes` component declaration. * 
 * This Component is to define the style of each TemplateItemTypes to show and redirect to types templates
 * @param {Object} template
 * @return TemplateItemTypes
*/
const TemplateItemTypes = ({ template }: { template: ITemplate }): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useSession()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  return (
    <Card
      className={classes.root}
      style={{cursor:'pointer'}}
      onClick={() => {
        if (user?.role === ROLES.SUPER_USER)
          history.push({ pathname: '/docengine/document-type', state: template })
      }}
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <CardContent>
        <Typography
          gutterBottom
          variant="h6"
          component="h5"
          className={classes.title}
        >
          {template.name}
        </Typography>
          <hr style={{marginTop:'13px', marginBottom:'5px'}}/>
        <Typography
          className={classes.description}
          variant="body2"
          color="textSecondary"
          component="p"
        >
          {template.description}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default TemplateItemTypes 